import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { trigger, style, animate, transition } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';



@Component({
    selector: 'app-not-found',
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
    imports: [CommonModule, TranslateModule],
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms', style({ opacity: 1 }))
            ])
        ])
    ]
})

export class NotFoundPageComponent implements OnInit, OnDestroy {
  // Simple looped audio player (same track as Producsounds)
  isPlaying: boolean = false;
  audio: HTMLAudioElement | null = null;
  currentTrack = {
    title: 'You Know',
    artist: 'Jeyslee',
    url: 'https://audio-applisound.s3.eu-west-3.amazonaws.com/coming_soon/Youknowapplisound.mp3'
  };

  constructor(private router: Router, private languageService: LanguageService) {}

  ngOnInit(): void {
    this.initAudio();
  }

  ngOnDestroy(): void {
    this.stopAudio();
  }

  initAudio(): void {
    this.audio = new Audio(this.currentTrack.url);
    this.audio.loop = true;
    this.audio.volume = 0.5;
  }

  togglePlay(): void {
    if (!this.audio) return;
    if (this.isPlaying) {
      this.pauseAudio();
    } else {
      this.playAudio();
    }
  }

  playAudio(): void {
    if (!this.audio) return;
    this.audio.play()
      .then(() => (this.isPlaying = true))
      .catch(err => console.error('Audio play error:', err));
  }

  pauseAudio(): void {
    if (!this.audio) return;
    this.audio.pause();
    this.isPlaying = false;
  }

  stopAudio(): void {
    if (!this.audio) return;
    this.audio.pause();
    this.audio.currentTime = 0;
    this.isPlaying = false;
  }

  retourAccueil(): void {
    const lang = this.languageService.getCurrentLanguage();
    if (lang && lang !== 'en') {
      this.router.navigate(['/', lang]);
    } else {
      this.router.navigate(['/']);
    }
  }
}
